import { render } from "./TestFile.vue?vue&type=template&id=4b883dcd"
import script from "./TestFile.vue?vue&type=script&lang=js"
export * from "./TestFile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__